import React from 'react';
import { Controller } from 'react-hook-form';
import { FormLabel } from './FormLabel';
import { Rating } from 'react-simple-star-rating';

const FormRating = ({ control, name, id, label, rules, ...props }) => {
  return (
    <div>
      {label && <FormLabel rules={rules} label={label} id={id} />}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <>
            <Rating onClick={(content) => field.onChange(content)} value={field.value} {...props} />
            {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
          </>
        )}
      />
    </div>
  );
};

export default FormRating;
